import { usePath } from './lib/router'
import { useAuthStore } from './lib/auth-store'
import { DemoBanner } from './components/DemoBanner'
import { SignupPage } from './pages/SignupPage'
import { LoginPage } from './pages/LoginPage'
import { VerifyEmailPage } from './pages/VerifyEmailPage'
import { DashboardPage } from './pages/DashboardPage'
import { ProjectDetailPage } from './pages/ProjectDetailPage'
import { SettingsPage } from './pages/SettingsPage'
import { AdminPage } from './pages/AdminPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { LandingPage } from './pages/LandingPage'
import { AcceptInvitePage } from './pages/AcceptInvitePage'
import { ImpressumPage } from './pages/legal/ImpressumPage'
import { PrivacyPage } from './pages/legal/PrivacyPage'
import { TermsPage } from './pages/legal/TermsPage'

export function App() {
  const path = usePath()
  const isDemo = useAuthStore((s) => s.isDemo)

  // Demo banner sits above every authenticated page so the read-only
  // intent stays visible while the visitor explores. Public pages
  // (landing, signup, login) don't show it — they're either pre-demo
  // entry points or dedicated to writes (signup/login).
  const banner = isDemo ? <DemoBanner /> : null

  // Public pages (no auth required)
  if (path === '/') return <LandingPage />
  if (path === '/signup') return <SignupPage />
  if (path === '/login') return <LoginPage />
  if (path === '/verify-email') return <VerifyEmailPage />
  if (path === '/forgot-password') return <ForgotPasswordPage />
  if (path === '/reset-password') return <ResetPasswordPage />
  if (path === '/terms') return <TermsPage />
  if (path === '/privacy') return <PrivacyPage />
  if (path === '/impressum') return <ImpressumPage />
  if (path === '/accept-invite') return <AcceptInvitePage />

  // Authenticated pages
  if (path === '/dashboard') return <>{banner}<DashboardPage /></>
  if (path === '/settings') return <>{banner}<SettingsPage /></>
  if (path === '/admin') return <>{banner}<AdminPage /></>

  // /projects/:id
  const projectMatch = path.match(/^\/projects\/([0-9a-f-]{36})\/?$/)
  if (projectMatch && projectMatch[1]) {
    return <>{banner}<ProjectDetailPage projectId={projectMatch[1]} /></>
  }

  return <LandingPage />
}
